import React from 'react'

export const ProgressHeader = ({progressTab, setProgressTab, progressList, validationErrors = {}}) => {
  
    return (
      
      <div style={{display:"flex", cursor:"pointer", minHeight:"60px", backgroundColor:"white", justifyContent:"center", alignItems:"center", marginTop:"15px", marginBottom:"15px"}}>
          {progressList?.map((item, index)=>{
               const hasError = validationErrors[`question_${index}`] || 
                              (index === progressList.length - 1 && validationErrors.personalData === true);
               const activeBackground = progressTab?.index === index ? {backgroundColor:"#CCC"} : {};
               const errorStyle = hasError ? {backgroundColor: "#ff0000", color: "#ffffff"} : {};
               const style = {
                 display: "flex",
                 justifyContent: "center",
                 alignItems: "center",
                 minHeight: "60px",
                 height: "100%",
                 ...activeBackground,
                 ...errorStyle
               };
              return(
              <div key={index} onClick={()=>{setProgressTab({...item, index})}} style={style}>
                  <h5 style={{padding:"10px"}}>{index+1}.{item?.tabTitle}</h5>
               </div>
              )
          })}
  
      </div>
    )
  }
